// extracted by mini-css-extract-plugin
export var ellipsesOverflow = "_cl-a";
export var fulfillmentFormRail = "_cl-9";
export var headerTitleRow = "_cl-c";
export var orderDetailsWrapper = "_cl-7";
export var orderLinkTrigger = "_cl-2";
export var paymentInformationGrid = "_cl-h";
export var paymentSummaryColumn = "_cl-i";
export var shipmentContainer = "_cl-b";
export var shipmentDetailsMainPane = "_cl-8";
export var shipmentNavigationCard = "_cl-5";
export var shipmentNavigationRail = "_cl-3";
export var shipmentNavigationRailHeader = "_cl-4";
export var shipmentSummaryFact = "_cl-e";
export var shipmentSummaryGrid = "_cl-d";
export var shipmentSummaryMetadataRow = "_cl-f";
export var shipmentSummaryTags = "_cl-g";
export var shipmentWorkspace = "_cl-0";
export var shipmentWorkspaceContent = "_cl-6";
export var shipmentWorkspaceHeader = "_cl-1";